import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ResponsiveRadar } from '@nivo/radar'

import './studentreport.css';

import {
  studentGetResult,
} from '../../../modules/student';


class StudentReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentData: null,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    this.setState({ studentData: data });
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;
    if (prevProps.data !== data) {
      this.setState({ studentData: data });
    }
  }

  constructJobs = () => {
    const { studentData } = this.state;
    return studentData.info.occupations.map((job, i) => {
      return (
        <div className="job-item" key={`job-${i}`}>{`< ${i + 1} > ${job}`}</div>
      );
    })
  }

  constructTable = () => {
    const { studentData } = this.state;
    const personalities = ['R', 'I', 'A', 'S', 'E', 'C'];
    let table = [(
      <div className="row header">
        <div className="name">性格特質<br />Personality Traits</div>
        {
          personalities.map((a, i) => <div className="score" key={`personality-${i}`}>{a}</div>)
        }
        <div className="score">分差(?)<br />Difference</div>
        <div className="score">反常(X)<br />Invalid</div>
      </div>
    )]

    let sections = [
      { name_tc: '活動', name_en: 'Activities', key: 'activitiesScore' },
      { name_tc: '技能', name_en: 'Competencies', key: 'competenciesScore' },
      { name_tc: '職業', name_en: 'Occupations', key: 'occupationsScore' },
      { name_tc: '自評 1 能力', name_en: 'Self-Estimates 1', key: 'self1Score' },
      { name_tc: '自評 2 能力', name_en: 'Self-Estimates 2', key: 'self2Score' },
      { name_tc: '總分數', name_en: 'Total Scores', key: 'totalScore' },
    ];

    let result = sections.map((item, i) => {
      let allValues = Object.keys(studentData[item.key]).map(key => key !== '_id' && studentData[item.key][key]).filter(e => e !== false);
      let maxValue = allValues.reduce((a, b) => Math.max(a, b));
      let minValue = allValues.reduce((a, b) => Math.min(a, b));
      console.log(item.key);
      return (
        <div className={item.key === 'totalScore' ? "row total" : 'row'} key={`row-${i}`}>
          <div className="name">{item.name_tc}<br />{item.name_en}</div>
          {
            personalities.map((p, j) => {
              return (
                <div
                  className={studentData[item.key][p] === maxValue ? "score max" : studentData[item.key][p] === minValue ? "score min" : "score"}
                  key={`score-${i}-${j}`}
                >
                  {
                    item.key === 'totalScore' ?
                      <span>{p}<br />{studentData[item.key][p]}</span>
                      :
                      studentData[item.key][p]
                  }
                </div>
              );
            })
          }
          <div className="score">{item.key === 'totalScore' ? <span>{''}<br />{maxValue - minValue}</span> : maxValue - minValue}</div>
          <div className="score">{(maxValue - minValue) <= 3 ? 'X' : ''}</div>
        </div>
      );
    });

    return table.concat(result);
  }

  constructRanking = () => {
    const { studentData } = this.state;
    const personalityMap = {
      R: { name_tc: '實際型', name_en: 'Realistic', type: 'R' },
      I: { name_tc: '探究型', name_en: 'Investigative', type: 'I' },
      A: { name_tc: '藝術型', name_en: 'Artistic', type: 'A' },
      S: { name_tc: '社交型', name_en: 'Social', type: 'S' },
      E: { name_tc: '企業型', name_en: 'Enterprising', type: 'E' },
      C: { name_tc: '常規型', name_en: 'Conventional', type: 'C' },
    };
    return studentData.ranking.map((rank, i) => {
      return (
        // <div className="rank">
        //   <div className="number" key={i}>{`第${i+1}名 ${i === 0 ? '1st' : i === 1 ? '2nd' : i === 2 ? '3rd' : `${i+1}th`}`}</div>
        //   {
        //     rank.map((p, j) => <div className="name" key={j}>{personalityMap[p].name_tc}<br/>{personalityMap[p].name_en}</div>)
        //   }
        // </div>
        <div className="rank small">
          <div className="number" key={i}>{i + 1}</div>
          <div className="name-container">
            {
              rank.map((p, j) => <div className={`name ${personalityMap[p].type}`} key={j}>{personalityMap[p].name_tc}<br />{personalityMap[p].name_en}</div>)
            }
          </div>
        </div>
      )
    });
  }

  render() {
    const { studentData } = this.state;
    const { style, isOverlay } = this.props;

    if (studentData) {
      const personalityMap = {
        R: { name_tc: '實際型', name_en: 'Realistic', type: 'R' },
        I: { name_tc: '探究型', name_en: 'Investigative', type: 'I' },
        A: { name_tc: '藝術型', name_en: 'Artistic', type: 'A' },
        S: { name_tc: '社交型', name_en: 'Social', type: 'S' },
        E: { name_tc: '企業型', name_en: 'Enterprising', type: 'E' },
        C: { name_tc: '常規型', name_en: 'Conventional', type: 'C' },
      };
      const totalScore = Object.keys(studentData['totalScore']).map((key) => { return { type: personalityMap[key].name_tc, score: studentData['totalScore'][key] } });

      return (
        <div className="report-wrap" id="report" style={{ ...style }}>
          {
            isOverlay &&
            <div className="transparent-overlay"></div>
          }
          <div className="report-box">
            <div className="logos">
              <img src={`${window.location.origin}/images/SDS%20Report%20Logo%202026.png`} alt="SDS Report Logo 2026" />
            </div>
            <div className="report-title">
              <div>職業性向測試結果報告<br />The Holland’s Self-Directed Search (SDS) Test Result Report</div>
            </div>
            <div className="student-info">
              <div className="row">
                <div className="left">{`學生姓名: ${studentData.info.nameChinese || studentData.info.nameEnglish}`}</div>
                <div className="right">{`班別及學號: ${studentData.classData.className} ${studentData.info.classNumber}`}</div>
              </div>
              <div className="row">
                <div className="left">{`學校名稱: ${studentData.school.name_tc || studentData.school.name_en}`}</div>
                <div className="right">{`年度: ${studentData.schoolQuota.year}`}</div>
              </div>
            </div>
            <div className="dream-job">
              <div className="title">夢想職業 / Occupational Daydreams</div>
              <div className="jobs">
                {
                  this.constructJobs()
                }
              </div>
            </div>
            <div className="result-table">
              <div className="title">Self-Directed Search Result (SDS-R-5-CHI/2019)</div>
              <div className="table-container">
                {
                  this.constructTable()
                }
              </div>
            </div>
            <div className="last-row">
              <div className="ranking-list">
                {
                  this.constructRanking()
                }
              </div>
              <div className="radar-container">
                <ResponsiveRadar
                  data={totalScore}
                  keys={['score']}
                  indexBy="type"
                  maxValue={56}
                  margin={{ top: 30, right: 40, bottom: 70, left: 40 }}
                  curve="linearClosed"
                  borderWidth={2}
                  borderColor={{ from: 'color' }}
                  gridLevels={5}
                  gridShape="linear"
                  gridLabelOffset={22}
                  enableDots={true}
                  dotSize={5}
                  dotColor={{ theme: 'background' }}
                  dotBorderWidth={2}
                  dotBorderColor={{ from: 'color' }}
                  enableDotLabel={true}
                  dotLabel="value"
                  dotLabelYOffset={-10}
                  colors={{ scheme: 'nivo' }}
                  fillOpacity={0.25}
                  blendMode="multiply"
                  animate={true}
                  motionConfig="wobbly"
                  isInteractive={true}
                />
              </div>
            </div>
            <div className="remarks">
              <div>備註 Remarks：</div>
              <div>
                <div>-分差(?): 該項目最高與最低分之差距</div>
                <div>Difference: The Difference between the highest and lowest Score.</div>
                <div>反常(X): 該項目出現全面同分或0分的情況</div>
                <div>Invalid: Same score on all items or 0 score in the category</div>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return '';
    }
  }

}


const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      studentGetResult,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(StudentReport);
